module.exports = __webpack_public_path__ + "static/img/mattermost.e5551a4d.png";